import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ChoiceTypeTableRow;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import { Table } from '@instructure/ui-table';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import generateComponentTheme from './theme';
import generateStyle from './styles';
import PropTypes from 'prop-types';
import { IconXSolid, IconCheckSolid } from '@instructure/ui-icons';
import { extractTextFromHtml } from '@instructure/quiz-interactions';
import t from '@instructure/quiz-i18n/es/format-message';
import { withStyleOverrides } from '@instructure/quiz-common';
export var ChoiceTypeTableRow = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ChoiceTypeTableRow = /*#__PURE__*/function (_Component) {
  function ChoiceTypeTableRow() {
    var _this;
    _classCallCheck(this, ChoiceTypeTableRow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChoiceTypeTableRow, [].concat(args));
    _defineProperty(_this, "renderIcon", function () {
      return jsx("div", {
        css: _this.props.styles.iconWrapper
      }, _this.props.choice.correct ? jsx(IconCheckSolid, null) : jsx(IconXSolid, null));
    });
    _defineProperty(_this, "renderMiddleCell", function (content) {
      return jsx("div", {
        css: _this.props.styles.correctRowBorder
      }, content);
    });
    _defineProperty(_this, "renderLastCell", function (content) {
      return jsx("div", {
        css: _this.props.styles.lastRowBorder
      }, content);
    });
    _defineProperty(_this, "answerLabel", function (correct) {
      return correct ? t('Correct answer') : t('Incorrect answer');
    });
    _defineProperty(_this, "extractChoiceText", function (choiceBody, correct) {
      var text = extractTextFromHtml(choiceBody);
      if (text.trim().length > 0) return text;
      return _this.answerLabel(correct);
    });
    _defineProperty(_this, "render", function () {
      var correct = _this.props.choice.correct;
      var choiceBody = _this.props.choice.body;
      var cellPadding = correct ? '0' : _this.props.styles.cellPadding;
      return jsx(Table.Row, {
        key: _this.props.choiceIndex
      }, jsx(Table.Cell, {
        themeOverride: {
          padding: '0px'
        }
      }, jsx(ScreenReaderContent, null, _this.answerLabel(correct)), _this.renderIcon()), jsx(Table.RowHeader, {
        themeOverride: {
          padding: cellPadding
        }
      }, _this.renderMiddleCell(_this.extractChoiceText(choiceBody, correct))), jsx(Table.Cell, {
        themeOverride: {
          padding: cellPadding
        }
      }, _this.renderMiddleCell(_this.props.choice.count)), jsx(Table.Cell, {
        themeOverride: {
          padding: cellPadding
        },
        textAlign: "center"
      }, _this.renderLastCell("".concat(_this.props.choice.percentage, "%"))));
    });
    return _this;
  }
  _inherits(ChoiceTypeTableRow, _Component);
  return _createClass(ChoiceTypeTableRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }]);
}(Component), _defineProperty(_ChoiceTypeTableRow, "displayName", 'Row'), _defineProperty(_ChoiceTypeTableRow, "componentId", "Quizzes".concat(_ChoiceTypeTableRow.displayName)), _defineProperty(_ChoiceTypeTableRow, "propTypes", {
  choice: PropTypes.shape({
    body: PropTypes.string,
    correct: PropTypes.bool,
    count: PropTypes.number,
    percentage: PropTypes.number
  }).isRequired,
  choiceIndex: PropTypes.number.isRequired,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _ChoiceTypeTableRow)) || _class);